/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseReferentialCategory } from '../../models/api-response-referential-category';
import { ReferentialCategory } from '../../models/referential-category';

export interface UpdateReferentialCategory$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: ReferentialCategory
}

export function updateReferentialCategory(http: HttpClient, rootUrl: string, params: UpdateReferentialCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialCategory>> {
  const rb = new RequestBuilder(rootUrl, updateReferentialCategory.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseReferentialCategory>;
    })
  );
}

updateReferentialCategory.PATH = '/v1/api/ui/referential/category/{ref}';
